import { useContext } from "react";
import MetadataContext from "../../Context/metadataContext";

export function usePlaceholders() {
  const { metadata } = useContext(MetadataContext);

  if (metadata.domainText === "Bizgraph") {
    return {
      smartChatPlaceholder: "Describe what you are looking for.",
      searchPlaceholder: "Company name, product or services",
    };
  }

  return {
    smartChatPlaceholder: metadata.smartChatPlaceholder,
    searchPlaceholder: metadata.searchPlaceholder,
  };
}
